import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${({ theme }) => theme.colors.background};

    img {
      height: auto;
      max-width: 100%;
    }
  }

  #swap-body{
    background: ${({ theme }) => theme.colors.card};
    #swap-currency-input, #swap-currency-output{
      background-color: transparent;
    }
    .container-amounts{
        background-color: ${({ theme }) => theme.colors.input};
        box-shadow: ${({ theme }) => theme.shadows.inset};
    }
    ${({ theme }) => theme.mediaQueries.sm} {
      background: ${({ theme }) => theme.colors.card};
      border: none;
      .container-amounts{
        background-color: ${({ theme }) => theme.colors.input};
        box-shadow: ${({ theme }) => theme.shadows.inset};
      }
      
    }
  }
  
`

export default GlobalStyle
